import {load} from '@shopify/theme-sections';

import '../sections/tagalys-recommendations';

import initDeliveryTimer from '../components/delivery-timer.js';

const template = 'product';

export default (function () {
  if (document.body.dataset.template !== template) return;

  load('*');

  initDeliveryTimer();

  const observeVisualSearchBtnAdded = (mutationList) => {
    mutationList.forEach((mutation) => {
      if (mutation.type !== 'childList' || !mutation.addedNodes || !mutation.addedNodes.length) return;

      Array.from(mutation.addedNodes).forEach((node) => {
        if (!node.hasAttribute('data-visual-search')) return;

        const productMain = document.querySelector('.product-main');
        const buttonWrapperContent = productMain && productMain.querySelector('.button-wrapper-content');
        if (!buttonWrapperContent) return;

        const visualSearchBtnClone = node.cloneNode(true);
        visualSearchBtnClone.classList.add('action-list--visual-search-btn');
        visualSearchBtnClone.setAttribute('type', 'button');

        const addToCartBtn = buttonWrapperContent.querySelector('.add-to-cart-btn');
        if (!addToCartBtn) return;

        if (addToCartBtn.nextSibling) {
          return buttonWrapperContent.insertBefore(visualSearchBtnClone, addToCartBtn.nextSibling);
        }

        return buttonWrapperContent.appendChild(visualSearchBtnClone);
      });
    });
  };

  const productImgBox = document.querySelector('.product-img-box');
  const observer = new MutationObserver(observeVisualSearchBtnAdded);
  const config = {attributes: true, childList: true};
  observer.observe(productImgBox, config);
})();
